import type {
	FieldErrorsImpl,
	FieldValues,
	FieldError as HookFieldError,
	Merge,
} from "react-hook-form";
import FieldError from "./errors/FieldError.tsx";

// No real functionality here yet, all the styling is done in tailwind.css
export default function Input<T extends FieldValues>({
	error,
	...props
}: React.InputHTMLAttributes<HTMLInputElement> & {
	type: Omit<React.HTMLInputTypeAttribute, "checkbox">;
	error?: HookFieldError | Merge<HookFieldError, FieldErrorsImpl<T>>;
}) {
	const classes = [props.className ?? ""];
	if (error) classes.push("has-error");
	if (props.type === "submit") classes.push("");

	return (
		<div className="w-full">
			<input
				{...props}
				className={classes.join(" ")}
				aria-invalid={error ? "true" : "false"}
				aria-errormessage={error?.message?.toString()}
			/>
			{error && <FieldError error={error} />}
		</div>
	);
}
